<template>
  <div class="kp-modular-section">
    <div v-if="jump.options_ids.length === 0">
      <label class="kp-modular-label">{{$t('edit.sidebar.select_the_answers')}}</label>
      <select class="klickart-select" @change="jumpUpdateOptionId({ jump, index: 0, event: $event })">
        <option value="" disabled selected>{{$t('edit.sidebar.choose_one_answer')}}</option>
        <option v-for="option in optionList" :value="option.id">{{ option.label }}</option>
      </select>
      <add-option-button :jump="jump" :show="true"></add-option-button>
    </div>
    <div v-else>
      <label class="kp-modular-label">{{$t('edit.sidebar.select_the_answers')}}</label>
      <div v-for="(optionId, index) in jump.options_ids">
        <div class="klickart-select-inline">
          <select class="klickart-select" @change="jumpUpdateOptionId({ jump, index, event: $event })">
            <option value="" disabled selected>{{$t('edit.sidebar.choose_one_answer')}}</option>
            <option v-for="option in optionList" :value="option.id" :selected="option.id === optionId">{{ option.label }}</option>
          </select>
          <div class="nav-button-inline">
            <remove-option-button :jump="jump" :index="index" :show="jump.options_ids.length > 1"></remove-option-button>
          </div>
        </div>
        <add-option-button :jump="jump" :show="index === jump.options_ids.length - 1"></add-option-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AddOptionButton from '../buttons/AddOption.vue';
import RemoveOptionButton from '../buttons/RemoveOption.vue';

export default {
  props: [
    'jump',
  ],
  components: {
    AddOptionButton,
    RemoveOptionButton,
  },
  computed: mapGetters({
    optionList: 'optionList',
  }),
  methods: mapActions([
    'jumpUpdateOptionId',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** MultipleAnswer.vue?a184b796
 **/